import React from 'react';
import { Card, Form } from 'react-bootstrap';

/** Shared section card used across Settings tabs */
export const SectionCard = ({ title, icon: Icon, description, children, className = '' }) => (
  <Card className={`border-0 shadow-sm h-100 ${className}`.trim()}>
    <Card.Body className="p-3">
      {(title || Icon) && (
        <div className="mb-2">
          <div className="d-flex align-items-center gap-2">
            {Icon ? (
              <span className="q2c-settings-section-icon">
                <Icon size={16} />
              </span>
            ) : null}
            {title ? <h6 className="mb-0 fw-semibold">{title}</h6> : null}
          </div>
          {description ? <p className="small text-muted mb-0 mt-1">{description}</p> : null}
        </div>
      )}
      {children}
    </Card.Body>
  </Card>
);

export const FieldHelp = ({ label, help, required, children }) => (
  <Form.Group className="mb-2">
    {label ? (
      <Form.Label className="fw-semibold small mb-1">
        {label}
        {required ? ' *' : ''}
      </Form.Label>
    ) : null}
    {children}
    {help ? <Form.Text muted className="d-block mt-1">{help}</Form.Text> : null}
  </Form.Group>
);

export const ToggleRow = ({ id, label, help, checked, onChange }) => (
  <div className="q2c-toggle-row mb-2">
    <div className="d-flex align-items-start justify-content-between gap-3">
      <div className="min-w-0">
        <div className="fw-semibold small">{label}</div>
        {help ? <div className="small text-muted mt-1">{help}</div> : null}
      </div>
      <Form.Check
        type="switch"
        id={id}
        checked={Boolean(checked)}
        onChange={(e) => onChange(e.target.checked)}
        className="flex-shrink-0 mt-1"
      />
    </div>
  </div>
);

export const setField = (setForm, field, value) => {
  setForm((prev) => ({ ...prev, [field]: value }));
};
